export default __webpack_public_path__ + "static/media/laosanwalk.fe186dc0.gif";